import { useSnapshot } from "valtio"
import type { CreatedTreeState, TreeNodesMap } from "./types"

export function useTree<T>(ts: CreatedTreeState<T>): TreeNodesMap {
  const treeSnap = useSnapshot(ts.tree)
  return treeSnap
}
